export function findPropertyDescriptor(obj: any, prop: PropertyKey) {
  while (obj) {
    let descriptor = Object.getOwnPropertyDescriptor(obj, prop);
    if (descriptor) {
      return descriptor;
    }
    obj = Object.getPrototypeOf(obj);
  }
  return null;
}
